module.exports = __webpack_public_path__ + "static/bluewaffle-f66c3b3160fecbbbd64d0f3e068ebb6d.jpeg";